import { NextRequest, NextResponse } from 'next/server';

export function militaryRouteHandler(_req: NextRequest): NextResponse {
  // TODO: Implement military route handler
  return NextResponse.next();
}

export function homeRouteHandler(_req: NextRequest): NextResponse {
  // TODO: Implement home route handler
  return NextResponse.next();
}